import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, first } from 'rxjs/operators';
import { SplashScreenService, ServerBlockService } from '@luzula/luzula-lib';
import { DataService } from './data.service';
import { klaereAlleFassungen } from './bohrpunkte/klaere-fassungen';
import { ZeichnungenService } from './zeichnungen.service';
import { GeomFeaturesService } from './geom-features.service';
import { ProjectService } from './project.service';

@Component({
    standalone: false,
    selector: 'bp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'bpweb';
  private splash = inject(SplashScreenService);
  private router = inject(Router);
  /** Server-/IP-Sperre-Erkennung — speist den Warn-Banner (siehe Template). */
  readonly serverBlock = inject(ServerBlockService);

  private modalService = inject(NgbModal);
  private ds = inject(DataService);
  /** Die beiden anderen Speicher mit gezeichneten Objekten. */
  private zeichnungen = inject(ZeichnungenService);
  private geomFeatures = inject(GeomFeaturesService);
  /** Die Projekt-Datenbank — ihre Fassungen liegen auf dem Server. */
  private projekt = inject(ProjectService);

  /**
   * „Jetzt klären" aus dem Balken über der Leiste: Alles, wovon zwei Fassungen
   * bestehen, nacheinander durchgehen.
   *
   * **Alle drei Speicher**, denn der Balken zählt auch alle drei: die Punkte,
   * die Zeichnungen und die Flächen des Karten-Editors. Bis zum 29.08.2026
   * klärte der Knopf nur die Punkte — was danach stehen blieb, konnte niemand
   * wegbekommen.
   *
   * Die Listen kommen aus den Diensten und werden beim Öffnen frisch gelesen —
   * in der Zwischenzeit kann jemand anders schon geklärt haben. Wer abbricht,
   * verliert nichts: Beide Fassungen bleiben stehen.
   */
  async klaereZweiFassungen(): Promise<void> {
    await klaereAlleFassungen(this.modalService, {
      punkte: this.ds,
      zeichnungen: this.zeichnungen,
      geometrien: this.geomFeatures,
      projekt: this.projekt,
    });
  }

  ngOnInit() {
    // Splash Screen wird von AlleBohrpunkteComponent versteckt
    // für andere Routen hier als Fallback verstecken
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      first()
    ).subscribe((event) => {
      const navEvent = event as NavigationEnd;
      // Für andere Routen als die Hauptseite den Splash sofort verstecken
      if (navEvent.url !== '/' && navEvent.url !== '') {
        this.splash.hide();
      }
    });
  }

  @HostListener('document:contextmenu', ['$event'])
  onContextMenu(event: MouseEvent) {
    event.preventDefault();
  }
}
